import { IVersion } from 'types/logs'
import { IPriceRequestDetailsFragment } from 'apps/marketplace/pages/spot-quote-tool/graphql/PriceRequestDetailsFragment'
import { PriceRequestSources } from '../constants/priceRequestSources'
import { IQuoteUpdate } from '../types'

export const formatPriceRequestVersions = (versions: IVersion[]) => {
  const result: IQuoteUpdate[] = []

  if (versions.length === 0) {
    return result
  }

  // we only care about changes to customer quote
  const reverseVersions = versions
    .filter(version => version.changes.customerQuote !== undefined)
    .reverse()
  // if the quote type doesn't change we are otherwise unable to know what it is for
  // a quote version, so we check the quote preceding it
  let lastQuoteType: string = reverseVersions[0].changes?.customerQuoteType?.[1] ?? null

  reverseVersions.forEach(version => {
    const author = version.author?.fullName ?? null
    const userType = version.author?.userType ?? null
    const customerQuoteValue = Number(version.changes.customerQuote?.[1])
    const customerQuote = Number.isNaN(customerQuoteValue) ? null : customerQuoteValue
    const customerQuoteType = version.changes.customerQuoteType?.[1] ?? lastQuoteType
    lastQuoteType = customerQuoteType
    const { id, occurredAt } = version
    result.push({
      id,
      author,
      userType,
      customerQuote,
      customerQuoteType,
      occurredAt,
    } as IQuoteUpdate)
  })
  return result.reverse()
}

export const formatPuDelDates = (
  pickupStartDate?: string | null,
  deliveryStartDate?: string | null
) => {
  const start = pickupStartDate ? pickupStartDate.split('-').slice(1, 3).join('/') : 'N/A'
  const end = deliveryStartDate ? deliveryStartDate.split('-').slice(1, 3).join('/') : 'N/A'
  return [start, end].join(' - ')
}

export const formatPriceRequestSource = (source?: string | null) => {
  if (typeof source === 'string') {
    return PriceRequestSources[source as keyof typeof PriceRequestSources]
  }
  return 'N/A'
}

export const formatQuote = (quote?: number | null) => {
  if (typeof quote === 'number') {
    const rounded = Number(quote.toFixed(2)).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
    return `$${rounded}`
  }
  return 'N/A'
}

export const formatAllInToDat = (allIn?: number | null, datRate?: number | null) => {
  if (allIn && datRate) {
    return `${(100 * (allIn / datRate)).toFixed(2)}%`
  }
  return 'N/A'
}

export const checkIfMostRecentQuotePresent = (
  quoteUpdates: IQuoteUpdate[],
  priceRequest: IPriceRequestDetailsFragment
) => {
  if (!priceRequest.customerQuote) {
    return true
  }
  const mostRecentUpdate = quoteUpdates[0]
  if (mostRecentUpdate?.customerQuote === priceRequest?.customerQuote) {
    return true
  }
  return false
}
